import { render, staticRenderFns } from "./SuperScoreComponentWidget.vue?vue&type=template&id=183564e8&scoped=true"
import script from "./SuperScoreComponentWidget.vue?vue&type=script&lang=ts"
export * from "./SuperScoreComponentWidget.vue?vue&type=script&lang=ts"
import style0 from "./SuperScoreComponentWidget.vue?vue&type=style&index=0&id=183564e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183564e8",
  null
  
)

export default component.exports